import QRCode from 'qrcode';

export async function generateColombiaPrint(data) {
  // Verificar que existan los datos necesarios
  if (!data || !data.document) {
    console.error('generateColombiaPrint: No se proporcionaron datos válidos');
    return null;
  }

  // Settings por defecto o desde window si está disponible
  const settings = window.settings || {
    type_document_identifications: [
      { id: 1, code: "11", name: "NIT" },
      { id: 2, code: "12", name: "Cédula de ciudadanía" },
      { id: 3, code: "13", name: "Cédula de extranjería" },
      { id: 4, code: "31", name: "NIT de otro país" },
      { id: 5, code: "21", name: "Tarjeta de extranjería" },
      { id: 6, code: "22", name: "Pasaporte" },
      { id: 7, code: "41", name: "Pasaporte de otro país" },
      { id: 8, code: "42", name: "Documento de identificación de otro país" },
      { id: 9, code: "91", name: "NUIP" }
    ],
    municipalities: [
      { id: "05001", name: "Medellín" },
      { id: "11001", name: "Bogotá" },
      { id: "76001", name: "Cali" },
      { id: "13001", name: "Cartagena" },
      { id: "08001", name: "Barranquilla" }
    ],

  };
  settings["type_liabilities"] = [ 
    {
      id: 5,
      name: "Gran contribuyente",
      code: "O-13",
    },
    {
      id: 7,
      name: "Autorretenedor",
      code: "O-15",
    },
    {
      id: 12,
      name: "Agente de retención IVA",
      code: "O-23",
    },
    {
      id: 20,
      name: "Régimen simple de tributación",
      code: "O-47",
    },
    {
      id: 29,
      name: "No aplica – Otros",
      code: "R-99-PN",
    },
  ];
  settings["type_organizations"] = [
    { id: 1, name: "PERSONA JURIDICA" },
    { id: 2, name: "PERSONA NATURAL" },

  ];
  settings["type_regimes"] = [
    { id: 1, name: " RESPONSABLE DEL IVA" },
    { id: 2, name: "NO RESPONSABLES DEL IVA" },
  ];

  let url_cufe = "https://catalogo-vpfe-hab.dian.gov.co/document/searchqr?documentkey=";
  
  if (data.company.environment && data.company.environment === "1") {
    url_cufe = "https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=";
  }

  let LS = 50;
  const itemsQty = data.items.length * LS;
  const elem = document.createElement("canvas");
  elem.width = 945;
  elem.height = 3500 + itemsQty * 3;
  let total = 0;
  const center = elem.width / 2;
  const left = 10;
  let line = 150;
  const right = elem.width - left;
  const ctx = elem.getContext("2d");

  const items = data.items;
  items.forEach((item) => {
    item.quantity = parseInt(item.quantity);
    item.price = parseInt(item.price);
    item.discount = parseInt(item.discount);
  });
  
  // let regimen = "NO RESPONSABLES DEL IVA";
  // if (data.seller.TaxLevelCode) {
  //   switch (data.seller.TaxLevelCode) {
  //     case "0":
  //       regimen = "NO RESPONSABLES DEL IVA";
  //       break;
  //     case "1":
  //       regimen = "RESPONSABLES DEL IVA";
  //       break;
  //     default:
  //       regimen = "NO RESPONSABLES DEL IVA";
  //   }
  // }

  // Definir la fuente monospace simple para impresora térmica
  // Consolas es más limpia, pero si no está disponible, usar monospace genérico
  const ticketFont = "Consolas, 'Lucida Console', Monaco, monospace";
  const boldFont = (size) => `${size}px ${ticketFont}`; // Sin bold para impresoras térmicas
  const normalFont = (size) => `${size}px ${ticketFont}`;
  
  ctx.font = normalFont(38);
  ctx.textAlign = "center";

  ctx.font = boldFont(50);
  ctx.fillText(data.company.PartyName, center, line);
  line += LS;
  ctx.font = normalFont(38);
  // ctx.fillText(data.seller.PartyName, center, line);


  // Buscar tipo de identificación de forma segura
  const typeIdDoc = settings["type_document_identifications"]?.find(
    (item) => item.code == data.company.typeid
  );
  const typeIdName = typeIdDoc ? typeIdDoc.name : "NIT";
  
  ctx.fillText(
    typeIdName + " : " + data.company.PartyIdentification,
    center,
    line
  );
  line += LS;


  // Buscar municipio de forma segura
  const municipality = settings["municipalities"]?.find(
    (item) => item.id == data.company.city_code
  );
  const municipalityName = municipality ? municipality.name : "";
  
  ctx.fillText(
    data.company.AddressLine + (municipalityName ? ", " + municipalityName : ""),
    center,
    line
  );
  if (data.document.invoice && data.document.cufe) {
    switch (data.document.doc_type) {
      case "FE":
      case "FC":
      case "NC":
        if (data.permit) {
          line += LS;
          ctx.fillText(
            "Resolución DIAN: " + data.permit.InvoiceAuthorization,
            center,
            line
          );
          line += LS;
          ctx.fillText(
            "Del: " +
              data.permit.Prefix +
              "-" +
              data.permit.AuthorizationFrom +
              " al " +
              data.permit.Prefix +
              "-" +
              data.permit.AuthorizationTo,
            center,
            line
          );
          line += LS;
          ctx.fillText(
            "Desde: " + data.permit.StartDate + " al " + data.permit.EndDate,
            center,
            line
          );
        }
        break;
    }
  }
  
  ctx.font = normalFont(38);
  line += LS;
  ctx.fillText("NO SOMOS GRANDES CONTRIBUYENTES", center, line);
  line += LS;
  ctx.fillText("ACTIVIDAD ECONOMICA PRINCIPAL: " + data.company.economic_activity, center, line);
  line += LS;

  console.log('data.company.type_liability_id:', data.company.type_liability_id);
  console.log('settings["type_liabilities"]:', settings);
  line += LS;
      const orgType = settings["type_organizations"].find(
        (item) => item.id == data.company.type_organization_id
      );
      ctx.fillText(orgType ? orgType.name : "No especificado", center, line);

      line += LS;
      const regimeType = settings["type_regimes"].find(
        (item) => item.id == data.company.type_regime_id
      );
      ctx.fillText(regimeType ? regimeType.name : "No especificado", center, line);
  line += LS;
      const liabilityType = settings["type_liabilities"].find(
        (item) => item.id == data.company.type_liability_id
      );
      ctx.fillText(liabilityType ? liabilityType.name : "No especificado", center, line);

 
   if (data.company.inc == "1") {
        line += LS;
        ctx.fillText("Responsable del INC", center, line);
      }

  ctx.font = normalFont(38);

  switch (data.document.doc_type) {
    case "FE":
      if (data.document.invoice) {
        line += LS;
        ctx.fillText("FACTURA ELECTRONICA DE VENTA", center, line);
        ctx.font = normalFont(38);
        line += LS;
        ctx.fillText("No. " + data.document.invoice, center, line);
      } else {
        line += LS;
        ctx.fillText("TICKET DE CAMBIO Y GARANTIAS", center, line);
        ctx.font = normalFont(38);
        line += LS;
        ctx.fillText("No. " + data.document.doc_number, center, line);
      }
      break;
    case "FC":
      if (data.document.invoice) {
        line += LS;
        ctx.fillText("FACTURA ELECTRONICA DE CONTINGENCIA", center, line);
        ctx.font = normalFont(38);
        line += LS;
        ctx.fillText("No. " + data.document.invoice, center, line);
      } else {
        line += LS;
        ctx.fillText("COMPROBANTE DE PAGO", center, line);
        ctx.font = normalFont(38);
        line += LS;
        ctx.fillText("No. " + data.document.doc_number, center, line);
      }
      break;
    case "pos":
      line += LS;
      ctx.fillText("DOCUMENTO EQUIVALENTE", center, line);
      line += LS;
      ctx.fillText("A LA FACTURA DE VENTA", center, line);
      line += LS;
      ctx.fillText("SISTEMA POS", center, line);
      ctx.font = normalFont(38);
      line += LS;
      ctx.fillText("No. " + data.document.invoice, center, line);
      break;
    case "NC":
      line += LS;
      ctx.fillText("NOTA CREDITO", center, line);
      ctx.font = normalFont(38);
      line += LS;
      ctx.fillText("No. " + data.document.doc_number, center, line);
      break;
    default:
      // code block
  }

  line += LS;
  ctx.fillText("Cajero: " + data.cajero, center, line);

  line += LS;
  ctx.fillText(data.document.issuedate, center, line);
  line += LS;
  ctx.beginPath();
  ctx.moveTo(left, line - 10);
  ctx.lineTo(right, line - 10);
  ctx.stroke();

  line += LS;
  ctx.textAlign = "start";
  let PartyTypeId = "";
  let buyerTypeDoc = null;
  if (data.buyer.PartyTypeId) {
    buyerTypeDoc = settings["type_document_identifications"]?.find(
      (item) => item.id == data.buyer.PartyTypeId
    );
    
  }
  PartyTypeId = buyerTypeDoc ? buyerTypeDoc.name : "CC";
    ctx.fillText(PartyTypeId + " : " + data.buyer.PartyIdentification, left, line);

  line += LS;
  ctx.font = normalFont(38);
  ctx.fillText("Nombre / Razón Social: ", left, line);
  ctx.font = normalFont(38);
  line += LS;
  ctx.fillText(data.buyer.PartyName, left, line);
  line += LS;
  ctx.fillText("Email     : " + data.buyer.PartyEmail, left, line);

  line += LS;
  line += LS;
  LS = 60;
  ctx.font = normalFont(38);
  ctx.textAlign = "center";
  ctx.fillText("Productos", center, line);
  line += LS;
  ctx.beginPath();
  ctx.moveTo(left, line - 10);
  ctx.lineTo(right, line - 10);
  ctx.stroke();
  line += LS;
  total = 0;
  let tdiscount = 0;
  let idx = 1;
  // Objeto para acumular totales por tasa de impuesto
  let taxSummary = {};
  
  ctx.textAlign = "start";
  ctx.fillText("Item", left, line);
  ctx.textAlign = "start";
  ctx.fillText("Detalle", left + 120, line);
  ctx.textAlign = "end";
  ctx.fillText("Cant.", right - 200, line);
  ctx.textAlign = "end";
  ctx.fillText("Valor", right, line);

  line += LS;
  items.forEach((row) => {
    const price = row.item_price * row.item_quantity;
    const discount = row.item_discount * row.item_quantity;
    const siniva = (row.item_price - row.item_tax) * row.item_quantity;
    
    // Calcular el porcentaje de impuesto para este item
    // El porcentaje se calcula sobre la base gravable (precio sin impuesto)
    let taxPercentage = 0;
    const baseGravable = row.item_price - row.item_tax;
    if (baseGravable > 0 && row.item_tax > 0) {
      taxPercentage = Math.round((row.item_tax / baseGravable) * 100);
    }
    
    // Acumular en el resumen de impuestos
    if (!taxSummary[taxPercentage]) {
      taxSummary[taxPercentage] = {
        base: 0,
        tax: 0
      };
    }
    taxSummary[taxPercentage].base += siniva;
    taxSummary[taxPercentage].tax += row.item_tax * row.item_quantity;

    ctx.textAlign = "start";
    ctx.fillText(idx, left, line);
    ctx.textAlign = "start";
    ctx.fillText(row.item_concept, left + 50, line);
    ctx.textAlign = "end";
    ctx.fillText(row.item_quantity, right - 200, line);
    ctx.textAlign = "end";
    ctx.fillText(siniva.toLocaleString(), right, line);
    line += LS;
    ctx.font = normalFont(38);
    ctx.textAlign = "start";
    ctx.fillText("Cod: " + row.item_code, left + 50, line);
    line += LS;
    idx += 1;

    if (discount > 0) {
      ctx.fillText(
        " Impuesto: $" + row.item_tax + " / Descuento: $" + discount.toLocaleString(),
        left + 50,
        line
      );
    } else {
      if (row.item_tax > 0) {
        let tax_percentage = 0;
        const baseGravable = row.item_price - row.item_tax;
        if (baseGravable > 0) {
          tax_percentage = row.item_tax / baseGravable; // ratio sobre base gravable
        }
        // Redondeo normal para mostrar el porcentaje correcto
        const taxPercDisplay = Math.round(tax_percentage * 100);
        ctx.fillText(
          "Impuesto " +
            taxPercDisplay +
            "% :" +
            (row.item_tax * row.item_quantity).toLocaleString("es"),
          left + 50,
          line
        );
      }
    }
    line += LS;
    ctx.font = normalFont(38);
    total += price;
    tdiscount += discount;
  });
  
  ctx.beginPath();
  ctx.moveTo(left, line - 10);
  ctx.lineTo(right, line - 10);
  ctx.stroke();
  line += LS;

  // Mostrar el resumen de impuestos por cada tasa
  // Ordenar las tasas de impuesto para mostrarlas de forma consistente
  const taxRates = Object.keys(taxSummary).sort((a, b) => Number(a) - Number(b));
  
  // Mostrar cada tasa de impuesto con su base y valor
  taxRates.forEach(rate => {
    const summary = taxSummary[rate];
    
    // Mostrar base gravable para esta tasa
    ctx.textAlign = "start";
    ctx.fillText(`Base gravable ${rate}%`, left, line);
    ctx.textAlign = "end";
    ctx.fillText(Math.ceil(summary.base).toLocaleString(), right, line);
    line += LS;
    
    // Mostrar el impuesto para esta tasa
    ctx.textAlign = "start";
    let taxName = "IVA";
    if (rate === "8") {
      taxName = "INC";
    }

    ctx.fillText(`${taxName} ${rate}%`, left, line);
    ctx.textAlign = "end";
    ctx.fillText(Math.ceil(summary.tax).toLocaleString(), right, line);
    line += LS;
  });
  
  // Si no hay items con impuesto, mostrar base gravable del total
  if (taxRates.length === 0) {
    ctx.textAlign = "start";
    ctx.fillText("Base gravable", left, line);
    ctx.textAlign = "end";
    ctx.fillText(total.toLocaleString(), right, line);
    line += LS;
  }
  
  // Línea separadora antes del total
  // ctx.beginPath();
  // ctx.moveTo(left + 200, line - 10);
  // ctx.lineTo(right, line - 10);
  // ctx.stroke();
  

  // Mostrar el TOTAL
  ctx.textAlign = "start";
  ctx.fillText("TOTAL", left, line);
  ctx.textAlign = "end";
  ctx.fillText(total.toLocaleString(), right, line);
  line += LS;

  if (tdiscount > 0) {
    ctx.textAlign = "start";
    ctx.fillText("Descuento aplicado", left, line);
    ctx.textAlign = "end";
    ctx.fillText("( " + tdiscount.toLocaleString() + " )", right, line);
    line += LS;
  }
  line += LS;
  ctx.textAlign = "start";
  ctx.fillText("Foma de pago: CONTADO", left, line);
  line += LS;
  ctx.textAlign = "center";
  ctx.fillText("Medio de pago", center, line);
  line += LS;
  
  data.payments.forEach((row) => {
    ctx.textAlign = "start";
    ctx.fillText(row.payment_concept , left, line);
    ctx.textAlign = "end";
    ctx.fillText(parseFloat(row.payment_value).toLocaleString(), right, line);
    line += LS;
    ctx.textAlign = "start";
    ctx.fillText( row.payment_reference, left, line);
    line += LS;
  });
  
  line += LS;
  ctx.textAlign = "center";
  if (window.seller && window.seller.store_footer) {
    const res = window.seller.store_footer.split("<br>");
    res.forEach((item) => {
      ctx.fillText(item, center, line);
      line += LS;
    });
  } else {
    ctx.fillText("! Gracias por su compra !", center, line);
  }
  
  ctx.font = normalFont(30);



  line += LS;
  ctx.beginPath();
  ctx.moveTo(left, line - 10);
  ctx.lineTo(right, line - 10);
  ctx.stroke();
  line += LS;

  // Solo mostrar información del proveedor de software si es una factura válida (con invoice Y cufe)
  if (data.document.invoice && data.document.cufe) {
    ctx.font = normalFont(30);
    ctx.textAlign = "center";
    ctx.fillText("Modo de Operacion  Software Propio", center, line);
    line += 35;
    ctx.fillText(data.company.PartyName, center, line);
    line += 35;
    const companyTypeDoc = settings["type_document_identifications"]?.find(
      (item) => item.code == data.company.typeid
    );
    const companyTypeIdName = companyTypeDoc ? companyTypeDoc.name : "NIT";
    
    ctx.fillText(
      companyTypeIdName + " : " + data.company.PartyIdentification,
      center,
      line
    );
    line += 35;
    ctx.textAlign = "center";
    ctx.fillText("Software fabricado  por :", center, line);
    line += 35;
    ctx.fillText("NGM Corp. NIT otro país: 764763603RC001", center, line);
    line += 35;
    ctx.fillText("Nombre del Software POSWEB-", center, line);
  }

  line += LS;
  
  // Crear lista de promesas para QR codes - removido ya que ahora se dibujan directamente
  
  // Si es una factura de contingencia (FC) sin invoice, mostrar mensaje especial
  if (data.document.doc_type === "FC" && !data.document.invoice) {
    ctx.textAlign = "center";
    ctx.fillText("ESTE DOCUMENTO NO ES VALIDO COMO FACTURA", center, line);
    line += 35;
    ctx.fillText("ESCANEE ESTE CODIGO QR", center, line);
    line += 35;
    ctx.fillText("PARA DESCARGAR SU FACTURA", center, line);
    line += 35;
    ctx.font = normalFont(38);
    
    // Generar QR para descargar la factura
    try {
      const dta = data.document.store + "_" + data.document.issuedate + "_" + data.document.doc_number;
      // TODO: Implementar encryptId si es necesario
      // const url_doc = encryptId(dta);
      const fullHost = `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ""
      }`;
      const url_ticket = fullHost + "/ticket/" + dta; // Por ahora sin encriptar
      
      const qrDataURL = await QRCode.toDataURL(url_ticket, {
        width: 200,
        margin: 1
      });
      
      // Dibujar el QR
      const qrImage = new Image();
      await new Promise((resolve, reject) => {
        qrImage.onload = resolve;
        qrImage.onerror = reject;
        qrImage.src = qrDataURL;
      });
      
      const qrSize = 200;
      const qrX = (elem.width - qrSize) / 2;
      ctx.drawImage(qrImage, qrX, line, qrSize, qrSize);
      line += qrSize + 20;
      
    } catch (err) {
      console.error('Error generando QR del ticket:', err);
    }
  }
  // Si tiene CUFE, imprimirlo normalmente
  else if (data.document.cufe) {
    ctx.textAlign = "center";
    const result = data.document.cufe.match(/.{1,38}/g) ?? [];
    ctx.font = normalFont(38);
    ctx.fillText("CUFE:", center, line);
    line += 35;
    result.forEach((itm) => {
      ctx.fillText(itm, center, line);
      line += 35;
    });

    // Generar y dibujar el QR del CUFE
    try {
      const qrDataURL = await QRCode.toDataURL(url_cufe + data.document.cufe, {
        width: 200,
        margin: 1
      });
      
      // Convertir el QR dataURL a imagen y dibujarla en el canvas
      const qrImage = new Image();
      await new Promise((resolve, reject) => {
        qrImage.onload = resolve;
        qrImage.onerror = reject;
        qrImage.src = qrDataURL;
      });
      
      // Dibujar el QR centrado
      const qrSize = 200;
      const qrX = (elem.width - qrSize) / 2;
      ctx.drawImage(qrImage, qrX, line, qrSize, qrSize);
      line += qrSize + 20;
      
    } catch (err) {
      console.error('Error generando QR del CUFE:', err);
    }

    if (data.document.cufe_nc) {
      const result_nc = data.document.cufe_nc.match(/.{1,38}/g) ?? [];
      ctx.font = normalFont(38);
      ctx.fillText("CUFE NC:", center, line);
      line += 35;
      result_nc.forEach((itm) => {
        ctx.fillText(itm, center, line);
        line += 35;
      });
    }
  }
  // Para otros documentos sin invoice (tickets normales)
  else if (!data.document.invoice) {
    ctx.textAlign = "center";
    ctx.fillText("ESTE DOCUMENTO NO ES VALIDO COMO FACTURA", center, line);
    line += 35;
    ctx.fillText("ESCANEE ESTE CODIGO QR", center, line);
    line += 35;
    ctx.fillText("PARA DESCARGAR SU FACTURA", center, line);
    line += 35;
    ctx.font = normalFont(38);
    
    // Generar QR para tickets
    try {
      const dta = data.document.store + "_" + data.document.issuedate + "_" + data.document.doc_number;
      // Por ahora usar un URL simple, se puede mejorar con encryptId más adelante
      const fullHost = `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ""
      }`;
      const url_ticket = fullHost + "/ticket/" + dta;
      
      const qrDataURL = await QRCode.toDataURL(url_ticket, {
        width: 200,
        margin: 1
      });
      
      // Dibujar el QR
      const qrImage = new Image();
      await new Promise((resolve, reject) => {
        qrImage.onload = resolve;
        qrImage.onerror = reject;
        qrImage.src = qrDataURL;
      });
      
      const qrSize = 200;
      const qrX = (elem.width - qrSize) / 2;
      ctx.drawImage(qrImage, qrX, line, qrSize, qrSize);
      line += qrSize + 20;
      
    } catch (err) {
      console.error('Error generando QR del ticket:', err);
    }
  }
  
  line += LS;
  line += LS;
  line += LS;
  line += LS;
  line += LS;

  // Retornar directamente el dataURL de la imagen
  return elem.toDataURL();
}